import "./HomeLoan.scss";
import HomeLoanGuard from "./HomeLoanGuard";
import { R_HLRoutes } from "../../utils/Routes";
import { lazy } from "react";
import SuspenseWrapper from "../../components/CustomLazyLoading/CustomLazyLoading";

const HomeloanDetails = lazy(() => import("./HomeloanDetails/HomeloanDetails"));
const InterestCertificate = lazy(
  () => import("./HomeloanInterestCertificate/InterestCertificate")
);
const HomeLoanStatement = lazy(
  () => import("./HomeLoanStatement/HomeLoanStatement")
);
const DisbursementRequest = lazy(
  () => import("./DisbursementRequest/DisbursementRequest")
);
const EMI_payment = lazy(() => import("./EMI_payments/EMI_payment"));
const TermsAndConditions = lazy(
  () => import("./TermsAndConditions/TermsAndConditions")
);
const HomeloanChangeEnach = lazy(
  () => import("./HomeloanChangeEnach/HomeloanChangeEnach")
);
const ChangeAddress = lazy(() => import("./ChangeAddress/ChangeAddress"));
const HomeLoanExcessEMIRefund = lazy(
  () => import("./HomeLoanExcessEMIRefund/HomeLoanExcessEMIRefund")
);
const Homeloanuploaddocument = lazy(
  () => import("./Homeloanuploaddocument/Homeloanuploaddocument")
);
const HomeloanServiceDetails = lazy(
  () => import("./HomeloanServiceDetails/HomeloanServiceDetails")
);
const ChangeEmiTenure = lazy(() => import("./HL_EmiTenure/ChangeEmiTenure"));
const TenureChangeCharges = lazy(
  () => import("./HL_EmiTenure/TenureChangeCharges/TenureChangeCharges")
);
const ChangeEmiMoreOptions = lazy(
  () => import("./HL_EmiTenure/TenureChangeOption3/ChangeEmiMoreOptions")
);
const ChangeEmiDate = lazy(() => import("./ChangeEmiDate/ChangeEmiDate"));
const HomeLoanTdsRefund = lazy(
  () => import("./HomeLoanTdsRefund/HomeLoanTdsRefund")
);
const HomeloanChangeEmail = lazy(
  () => import("./HomeloanChangeEmail/HomeloanChangeEmail")
);
const HLBalanceConfirmationLetter = lazy(
  () => import("./HLBalanceConfirmationLetter/HLBalanceConfirmationLetter")
);
const HomeLoanChangeMobile = lazy(
  () => import("./HomeLoanChangeMobile/HomeLoanChangeMobile")
);
const ChangeEmiSelectDate = lazy(
  () => import("./ChangeEmiDate/ChangeEmiSelectDate")
);
const ChangeEmiDateUploadDocument = lazy(
  () => import("./ChangeEmiDate/ChangeEmiDateUploadDocument")
);

const HomeloanRoutesFn = () => {
  return [
    {
      path: R_HLRoutes.home_loan_baseUrl,
      element: <HomeLoanGuard />,
      children: [
        {
          path: R_HLRoutes.home_loan_details,
          element: <SuspenseWrapper LazyLoadingComponent={HomeloanDetails} />,
        },
        {
          path: R_HLRoutes.interest_certificate,
          element: (
            <SuspenseWrapper LazyLoadingComponent={InterestCertificate} />
          ),
        },
        {
          path: R_HLRoutes.account_statement,
          element: <SuspenseWrapper LazyLoadingComponent={HomeLoanStatement} />,
        },
        {
          path: R_HLRoutes.disbursement_request,
          element: (
            <SuspenseWrapper LazyLoadingComponent={DisbursementRequest} />
          ),
        },
        {
          path: R_HLRoutes.emi_payment,
          element: <SuspenseWrapper LazyLoadingComponent={EMI_payment} />,
        },
        {
          path: R_HLRoutes.terms_and_conditions,
          element: (
            <SuspenseWrapper LazyLoadingComponent={TermsAndConditions} />
          ),
        },
        {
          path: R_HLRoutes.change_enach,
          element: (
            <SuspenseWrapper LazyLoadingComponent={HomeloanChangeEnach} />
          ),
        },
        {
          path: R_HLRoutes.change_address,
          element: <SuspenseWrapper LazyLoadingComponent={ChangeAddress} />,
        },
        {
          path: R_HLRoutes.excess_emi_refund,
          element: (
            <SuspenseWrapper LazyLoadingComponent={HomeLoanExcessEMIRefund} />
          ),
        },
        {
          path: R_HLRoutes.document_upload,
          element: (
            <SuspenseWrapper LazyLoadingComponent={Homeloanuploaddocument} />
          ),
        },
        {
          path: R_HLRoutes.home_loan_service_request,
          element: (
            <SuspenseWrapper LazyLoadingComponent={HomeloanServiceDetails} />
          ),
        },
        {
          path: R_HLRoutes.home_loan_change_emi_tenure,
          element: <SuspenseWrapper LazyLoadingComponent={ChangeEmiTenure} />,
          children: [
            {
              path: R_HLRoutes.home_loan_change_emi_tenure_charges,
              element: (
                <SuspenseWrapper LazyLoadingComponent={TenureChangeCharges} />
              ),
            },
            {
              path: R_HLRoutes.home_loan_change_emi_tenure_option3,
              element: (
                <SuspenseWrapper LazyLoadingComponent={ChangeEmiMoreOptions} />
              ),
            },
          ],
        },
        {
          path: R_HLRoutes.home_loan_change_emi_date,
          element: <SuspenseWrapper LazyLoadingComponent={ChangeEmiDate} />,
        },
        {
          path: R_HLRoutes.home_loan_tds_request,
          element: <SuspenseWrapper LazyLoadingComponent={HomeLoanTdsRefund} />,
        },
        {
          path: R_HLRoutes.home_loan_change_email,
          element: (
            <SuspenseWrapper LazyLoadingComponent={HomeloanChangeEmail} />
          ),
        },
        {
          path: R_HLRoutes.Balance_Confirmation_Letter,
          element: (
            <SuspenseWrapper
              LazyLoadingComponent={HLBalanceConfirmationLetter}
            />
          ),
        },
        {
          path: R_HLRoutes.home_loan_change_mobile,
          element: (
            <SuspenseWrapper LazyLoadingComponent={HomeLoanChangeMobile} />
          ),
        },
        {
          path: R_HLRoutes.home_loan_service_request,
          element: (
            <SuspenseWrapper LazyLoadingComponent={HomeloanServiceDetails} />
          ),
        },
        {
          path: R_HLRoutes.change_emi_select_date,
          element: (
            <SuspenseWrapper LazyLoadingComponent={ChangeEmiSelectDate} />
          ),
        },
        {
          path: R_HLRoutes.change_emi_upload_doc,
          element: (
            <SuspenseWrapper
              LazyLoadingComponent={ChangeEmiDateUploadDocument}
            />
          ),
        },
      ],
    },
  ];
};
export { HomeloanRoutesFn };
